module.exports = __webpack_public_path__ + "img/9c19bb4.svg";